import {API} from 'aws-amplify';
import axios from 'axios';

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';
const baseURL = process.env.REACT_APP_APIURL;

export async function addAssetApi(queryObj: any) {
  const { asset, userId } = queryObj;
  if (isLocalAuth) {
    return axios.post(`${baseURL}/asset/add`, { userId, asset }).then(res => res.data);
  }
  return API.post('Backend', "/asset/add", {body: { userId, asset }});
}
export async function getAssetApi(userId: any) {
  if (isLocalAuth) {
    return axios.get(`${baseURL}/asset/get`, { params: { userId } }).then(res => res.data);
  }
  return API.get('Backend', "/asset/get", { queryStringParameters: { userId } });
}
export async function deleteAssetApi(queryObj: any) {
  const { userId, assetId } = queryObj;
  if (isLocalAuth) {
    return axios.delete(`${baseURL}/asset/remove`, { params: { userId, assetId } }).then(res => res.data);
  }
  return API.del('Backend', "/asset/remove", { queryStringParameters: { userId, assetId } });
}

export async function addMusicApi(queryObj: any) {
  const { asset, userId } = queryObj;
  if (isLocalAuth) {
    return axios.post(`${baseURL}/asset/add/music`, { userId, asset }).then(res => res.data);
  }
  return API.post('Backend', "/asset/add/music", { body: { userId, asset }});
}
export async function getMusicApi(userId: any) {
  if (isLocalAuth) {
    return axios.get(`${baseURL}/asset/get/music`, { params: { userId } }).then(res => res.data);
  }
  return API.get('Backend', "/asset/get/music", { queryStringParameters: { userId } });
}
export async function deleteMusicApi(queryObj: any) {
  const { userId, assetId } = queryObj;
  if (isLocalAuth) {
    return axios.delete(`${baseURL}/asset/remove/music`, { params: { userId, assetId } }).then(res => res.data);
  }
  return API.del('Backend', "/asset/remove/music", { queryStringParameters: { userId, assetId } });
}
export const getTemplatesApi = () => {
  return API.get('Backend', "/campaign/templates", {});
};
export const getIndustriesAPI = () => {
  if (isLocalAuth) {
    return axios.get(`${baseURL}/industry`).then(res => res.data);
  }
  return API.get('Backend', "/industry", {});
}

export const getPreviewApi = (settings: any) => {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/user/preview/`, settings).then(res => res.data);
  }
  return API.post('Backend', "/user/preview/", {body: settings});
}

export const saveSettingsApi = (settings: any) => {
  if (isLocalAuth) {
    return axios.post(`${baseURL}/user/template/`, settings).then(res => res.data);
  }
  return API.post('Backend', "/user/template/", {body: settings});
}

export async function getPublicMusicApi() {
  if (isLocalAuth) {
    return axios.get(`${baseURL}/asset/getpublicmusic`).then(res => res.data);
  }
  return API.get('Backend', "/asset/getpublicmusic", {});
}
